import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage/index";
import Login from "./Admin/Login.js/index";
import Dashboard from "./Admin/Dashbaord/index";
import ProtectedRoute from "../services/ProtectedRoute";
import UserList from "./Admin/User/UserList";
import CreateUser from "./Admin/User/CreateList";
import ViewAndUpdate from "./Admin/User/ViewAndUpdate";
import AllBillsList from "./Admin/Bills/AllBillsList";
// import CreateNewBill from "./Admin/Bills/CreateNewBill";
import ViewBill from "./Admin/Bills/ViewBill";
import Bookings from "./Admin/User/Bookings";
import Contact from "./Admin/User/Contact";
import GalleryImages from "./Admin/User/GalleryImages";
import { AppDataProvider } from "../context";
import EditBill from "./Admin/Bills/EditBill";
import CreateNewBill from "./Admin/Bills/createNewBill/CreateNewBill";


const AppNavigator = () => {

  return (
    <BrowserRouter>
      <Routes>
      
        <Route path="/" element={<LandingPage />} />

      
        <Route
          path="/admin/*"
          element={
            <AppDataProvider>
              <Routes>
                <Route path="login" element={<Login />} />

                <Route
                  path="dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="dashboard/create-user"
                  element={
                    <ProtectedRoute>
                      <CreateUser />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="dashboard/all-user"
                  element={
                    <ProtectedRoute>
                      <UserList />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="dashboard/view-update/:id"
                  element={
                    <ProtectedRoute>
                      <ViewAndUpdate />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="dashboard/bills-list"
                  element={
                    <ProtectedRoute>
                      <AllBillsList />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="dashboard/create-bill"
                  element={
                    <ProtectedRoute>
                      <CreateNewBill />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="dashboard/view-bill/:id"
                  element={
                    <ProtectedRoute>
                      <ViewBill />
                    </ProtectedRoute>
                  }
                />

                 <Route
                  path="dashboard/edit-bill/:id"
                  element={
                    <ProtectedRoute>
                      <EditBill />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="dashboard/bookings"
                  element={
                    <ProtectedRoute>
                      <Bookings />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="dashboard/contacts"
                  element={
                    <ProtectedRoute>
                      <Contact />
                    </ProtectedRoute>
                  }
                />

                 <Route
                  path="dashboard/gallery"
                  element={
                    <ProtectedRoute>
                      <GalleryImages />
                    </ProtectedRoute>
                  }
                />
              </Routes>

              
            </AppDataProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default AppNavigator;
